"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette2, _theme$palette3, _theme$palette3$prima, _theme$palette4, _theme$palette5, _theme$palette5$prima;
  return {
    header: _defineProperty({
      alignItems: "center",
      background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main,
      display: "flex",
      justifyContent: "space-between",
      padding: theme.spacing(2)
    }, theme.breakpoints.up("md"), {
      padding: theme.spacing(3)
    }),
    headline: {
      color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.getContrastText((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$prima = _theme$palette3.primary) === null || _theme$palette3$prima === void 0 ? void 0 : _theme$palette3$prima.main),
      fontSize: "1.375rem",
      fontWeight: theme.typography.fontWeightBold
    },
    closeButton: {
      marginRight: theme.spacing(-1),
      "& svg path": {
        fill: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : _theme$palette4.getContrastText((_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 ? void 0 : (_theme$palette5$prima = _theme$palette5.primary) === null || _theme$palette5$prima === void 0 ? void 0 : _theme$palette5$prima.main)
      }
    }
  };
});
var _default = styles;
exports.default = _default;